import React from 'react';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../../config/Translate";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import AppAnimate from "../../../../components/AppAnimate";
import AppCard from "../../../../components/layouts/components/AppCard";
import Grid from "@material-ui/core/Grid/Grid";
import AppCardLoaderFields from "../../../../components/Skeletons/AppCardLoaderFields";
import EditAttributesRoundedIcon from '@material-ui/icons/EditAttributesRounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import {List, ListItem, ListItemIcon, ListItemText} from "@material-ui/core";
import axios from "axios";
import {defaultVariabls} from "../../../../../config";
import {setStore} from "trim-redux";
import DragIndicatorRoundedIcon from '@material-ui/icons/DragIndicatorRounded';
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import RemoveCircleRoundedIcon from '@material-ui/icons/RemoveCircleRounded';
import AddNewVariable from "./AddNewVariable";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
class ChooseVariables extends React.Component {

    state = {
        category:this.props.category,
        variables:[],
        loading: true,
        removeLoading: false,
        SubmitLoading: false,
    };
    componentDidMount(){
        if(!!this.props.category){
            this.loadData();
        }else{
            this.setState({
                loading:false
            })
        }
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/categoryVariables/get/${this.props.category}`, config)
                .then(response => {
                    this.setState({
                        variables:response.data,
                        loading:false,
                        removeLoading:false
                    })

                }).catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false,
                        removeLoading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    async detachVariable(id){
        this.setState({
            removeLoading:true
        })
        let loginToken = localStorage.getItem('ACT');
        let data = new FormData();
        data.append('category', this.state.category);
        data.append('variable', id);
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            axios.post(`${defaultVariabls.url}/categoryVariable/detach`,data, config)
                .then(response => {
                    this.loadData();
                }).catch(error => {
                    console.log(error.response)
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    classes = this.props.classes;
    render(){
        let {variables,removeLoading} = this.state;
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} style={{marginTop:10}}>
                {
                    <Grid container spacing={2} justify="center" >
                        <Grid item xs={12}>
                            <AppCard
                                title={Translate.chooseVariables}
                                action={
                                    <IconButton>
                                    <EditAttributesRoundedIcon color="primary"/>
                                    </IconButton>
                                }>
                                {
                                    this.state.loading ? <AppCardLoaderFields/> :
                                        <Grid container spacing={2} justify="center" alignItems="center">
                                            <Grid item xs={12}>
                                                <List>
                                                    {variables.map((item, index) => (
                                                        <ListItem
                                                            key={index}
                                                        >
                                                            <ListItemIcon>
                                                                <DragIndicatorRoundedIcon />
                                                            </ListItemIcon>
                                                            <ListItemText
                                                                primary={item.name}
                                                                secondary={item.description}
                                                            />
                                                            <ListItemSecondaryAction>
                                                                <IconButton edge="end" aria-label="comments" onClick={() => this.detachVariable(item.id)}>
                                                                    <RemoveCircleRoundedIcon size="small" style={{color:"#ef6b2c"}}/>
                                                                </IconButton>
                                                            </ListItemSecondaryAction>
                                                        </ListItem>
                                                    ))}
                                                </List>
                                            </Grid>
                                            <Grid item xs={12}>
                                                {
                                                    removeLoading ?
                                                        <LinearProgress />
                                                    : null
                                                }
                                            </Grid>
                                            <Grid item xs={12}>
                                                <AddNewVariable excludeCategory={this.props.category} reload={this.loadData.bind(this)}/>
                                            </Grid>
                                        </Grid>
                                }
                            </AppCard>
                        </Grid>
                    </Grid>

                }
            </AppAnimate>

        );
    }
}

export default withSnackbar(withRouter(withStyles(Styles)(ChooseVariables)));